<template>
    <div class="page">
        <!-- 搜索 presentName  -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="商品名称">
                <el-input v-model="queryForm.cardName"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopCardPresentList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopCardPresent">新建</el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editShopCardPresent(null)"
                        >修改</el-button
                    >
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopCardPresent(null)"
                        >删除</el-button
                    >
                </div>

                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <!-- <span title="导出数据" class="icon-box" @click="exportShopCardPresentList">
                        <Icon color="#606266">
                            <ArrowDownload24Regular />
                        </Icon>
                    </span> -->
                    <span class="icon-box" @click="refreshShopCardPresentList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="shopCardPresentList"
                row-key="id"
                border
                :header-row-style="{ height: '10px' }"
                :header-cell-style="{ padding: '10px' }"
                :row-style="{ height: '9px' }"
                :cell-style="{ padding: '9px' }"
                @selection-change="handleSelectionChange"
                size="small"
                height="100%"
            >
                <el-table-column align="center" type="selection" width="60"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="coverPic" label="卡片封面" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.coverPic">
                            <div vertical-align:middle>
                                <img
                                    style="margin-left: 50%; transform: translate(-50%, 0)"
                                    :src="scope.row.coverPic"
                                    alt=""
                                    class="w-28 h-21 log-img"
                                />
                            </div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="productId" label="商品名称" width="180">
                    <template slot-scope="scope">
                        <div>{{ scope.row.product.productName }}</div>
                    </template>
                </el-table-column>

                <!-- presentPrice -->
                <el-table-column :show-overflow-tooltip="true" align="center" prop="presentPrice" label="商品价值(元)" width="180">
                    <template slot-scope="scope">
                        <div>{{ scope.row.product.shopPrice }}</div>
                        <!-- <div v-else>--</div> -->
                    </template>
                </el-table-column>

                <el-table-column :show-overflow-tooltip="true" align="center" prop="expiredTime" label="过期时间(年)" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="创建时间"> </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="200">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkShopCardPresent(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editShopCardPresent(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteShopCardPresent(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="shopCardPresentStates[shopCardPresentState]"
                :visible.sync="showDialog"
                width="400px"
                :modal='false'
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="shopCardPresent"
                        ref="shopCardPresentForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <!-- <el-form-item label="产品" prop="productId" label-width="80px">
                            <el-input
                                size="small"
                                v-model="shopCardPresent.productId"
                                :disabled="shopCardPresentState == 'check'"
                            ></el-input>
                        </el-form-item> -->
                        <!--  -->
                        <el-form-item label="商品种类" prop="productId" label-width="80px">
                            <GridSelect
                                style="width: 200px"
                                title="选择商品"
                                labelName="productName"
                                labelValue="id"
                                :value="shopCardPresent.productId"
                                :limit="1"
                                size="small"
                                placeholder="请选择商品"
                                @getValue="getValuebrandId"
                                :disabled="shopCardPresentState == 'check'"
                                :columns="PRODUCT_code"
                                :searchs="PRODUCT_search"
                                dataListUrl="/shop/product/findList"
                                entityBeanName="shopProduct"
                                queryEntityUrl="/shop/product/get"
                            >
                            </GridSelect>
                        </el-form-item>
                        <el-form-item label="卡片封面" prop="coverPic" label-width="80px">
                            <el-upload
                                action=""
                                :disabled="shopCardPresentState == 'check'"
                                class="avatar-uploader"
                                :show-file-list="false"
                                :http-request="uploadAvatar"
                                style="width: 200px"
                            >
                                <img v-if="shopCardPresent.coverPic" :src="shopCardPresent.coverPic" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>

                        <el-form-item label="过期时间" prop="expiredTime" label-width="80px">
                            <el-input-number
                                :disabled="shopCardPresentState == 'check'"
                                v-model="shopCardPresent.expiredTime"
                                :min="1"
                                style="width: 200px"
                                label="描述文字"
                            ></el-input-number>

                            <!-- <el-input
                                v-model.number="shopCardPresent.expiredTime"
                                :disabled="shopCardPresentState == 'check'"
                                style="width: 200px"
                            ></el-input> -->
                        </el-form-item>
                    </el-form>
                </div>

                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button type="primary" @click="submitForm" v-if="shopCardPresentState != 'check'">确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import { PRODUCT, PRODUCT_SEARCH } from '@/utils/constant.js'
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopCardPresentList();
                this.getShopCardPresentList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopCardPresentList();
                this.getShopCardPresentList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            PRODUCT_code: PRODUCT,
            PRODUCT_search: PRODUCT_SEARCH,
            shopProductCategory: {
                categoryPic: '' //类别图片
            },
            addtimeRange: [], //范围时间
            //时间
            time: '',

            queryForm: {
                //搜索查询
                productId: null,
                // productId: '', //产品
                coverPic: '', //封面
                startAddtime: '', //开始时间
                endAddtime: '', //结束时间
                // expiredTime: '', //过期时间
                expiredTime: ''
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopCardPresentState: 'add',
            shopCardPresentStates: {
                add: '新建礼品卡',
                check: '查看礼品卡',
                edit: '修改礼品卡'
            },

            multipleSelection: [],
            shopCardPresentList: [],
            shopCardPresent: {
                productId: null,
                // productId: '', //产品
                coverPic: '', //封面
                // expiredTime: '', //过期时间
                expiredTime: ''
            },
            btnLoading: false,

            rules: {
                productId: [{ required: true, message: '商品种类不能为空', trigger: 'blur' }],
                coverPic: [{ required: true, message: '卡片封面不能为空', trigger: 'blur' }],
                expiredTime: [
                    { required: true, message: '过期时间不能为空', trigger: 'blur' },
                    { type: 'number', message: '过期时间必须为数字值' }
                ]
            }
        };
    },
    created() {
        this.getShopCardPresentList();
    },
    methods: {
        getValuebrandId(value) {
            this.shopCardPresent.productId = value;
            console.log(value);
            console.log(this.shopCardPresent.productId);
        },
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!types.includes(file.type)) {
                this.$message({
                    message: '只能上传图片格式的文件，png.jpg或者jpeg',
                    type: 'error',
                    showClose: true,
                    duration: 2000
                });
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(`/mpp/image/upload`, formData).then((res) => {
                console.log({ res });
                if (res.success) {
                    this.shopCardPresent.coverPic = res.url;
                }
            });
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopCardPresentList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopCardPresentList = [];
        },
        resetDialog() {
            //重置
            this.shopCardPresentState = 'add';
            this.showDialog = false;
            this.queryForm = {
                productId: '', //产品
                coverPic: '', //封面
                startAddtime: '', //开始时间
                endAddtime: '', //结束时间
                // expiredTime: '', //过期时间
                expiredTime: ''
                // categoryPic: ''
            };
            this.addtimeRange = [];
            this.getShopCardPresentList();
        },
        closeDialog() {
            //关闭
            this.showDialog = false;
            // this.resetDialog();
            this.shopCardPresent = {
                // updateUserId: '',
                productId: '', //产品
                coverPic: '', //封面
                expiredTime: '' //过期时间
            };
            this.$refs.shopCardPresentForm.resetFields();
        },
        // getValuebrandId(value) {
        //     this.shopCard.detailId = value;
        // },
        submitForm() {
            if (this.shopCardPresentState == 'add') {
                this.$refs.shopCardPresentForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        console.log(this.shopCardPresent);
                        post(`/shop/shopcardpresent/add`, { ...this.shopCardPresent }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopCardPresentList();
                                this.resetDialog();
                                this.getShopCardPresentList();
                            }
                        });
                    }
                });
            } else if (this.shopCardPresentState == 'edit') {
                this.$refs.shopCardPresentForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        delete this.shopCardPresent.product
                        post(`/shop/shopcardpresent/edit`, { ...this.shopCardPresent }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopCardPresentList();
                                this.resetDialog();
                                this.getShopCardPresentList();
                            }
                        });
                    }
                });
            }
            // this.closeDialog();
            // this.showDialog = false;
        },
        //增加
        addShopCardPresent() {
            this.showDialog = true;
            this.shopCardPresentState = 'add';
        },
        //查看
        checkShopCardPresent(shopCardPresentId) {
            console.log(shopCardPresentId);
            this.currentShopCardPresentId = shopCardPresentId;

            this.getShopCardPresentById();
            this.showDialog = true;
            this.shopCardPresentState = 'check';
        },
        //修改
        editShopCardPresent(shopCardPresentId) {
            console.log('shopCardPresent', shopCardPresentId);
            if (shopCardPresentId) {
                this.currentShopCardPresentId = shopCardPresentId;
                this.getShopCardPresentById();
            } else {
                this.shopCardPresent = { ...this.shopCardPresent, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopCardPresentState = 'edit';
        },
        //删除
        deleteShopCardPresent(shopCardPresentId) {
            let ids = '';
            if (shopCardPresentId) {
                ids = shopCardPresentId;
            } else {
                ids = this.multipleSelection.map((shopCardPresent) => shopCardPresent.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/shopcardpresent/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopCardPresentList();
                            this.getShopCardPresentList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopCardPresentList() {
            this.resetShopCardPresentList();
            this.getShopCardPresentList();
        },
        getShopCardPresentList(query = {}) {
            this.queryForm.startAddtime = '';
            this.queryForm.endAddtime = '';
            if (this.addtimeRange != null) {
                this.queryForm.startAddtime = this.addtimeRange[0];
                this.queryForm.endAddtime = this.addtimeRange[1];
            }
            this.loading = true;
            get(`/shop/shopcardpresent/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    console.log(res.page.list);
                    this.shopCardPresentList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getShopCardPresentById() {
            get(`/shop/shopcardpresent/get`, { id: this.currentShopCardPresentId }).then((res) => {
                if (res.success) {
                    this.shopCardPresent = { ...this.shopCardPresent, ...res.shopCardPresent };
                }
            });
        },
        /**
         * 导出信息
         */
        exportShopCardPresentList() {
            //this.btnLoading = true;
            exprotExcel(`/shop/shopcardpresent/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        // importTemplate() {
        //     this.btnLoading = true;
        //     importTemplate(`/shop/shopcardpresent/importTemplate`, this.btnLoading);
        // },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        // upload(params) {
        //     const file = params.file;
        //     const formData = new FormData();
        //     formData.append('file', file);
        //     console.log({ formData });
        //     importDate(`/shop/shopcardpresent/importData`, formData);
        //     this.refreshShopCardPresentList();
        // },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopCardPresentList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopCardPresentList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.el-upload {
    width: 200px !important;
}
::v-deep .el-upload--text {
    width: 200px;
}
// ::v-deep .log-img {
//     margin: 0 auto;
// }
.el-icon-plus {
    margin-top: 38%;
    font-size: 25px;
}
// ::v-deep .el-table__body-wrapper{
//     height: 484px;
// }
</style>
